module.exports = __webpack_public_path__ + "img/thumbnail-side-by-side-feetscare.86ac7387.webp";